<app-iframe #appIframe [route]="url$ | async" [loading]="loading$ | async">
</app-iframe>
